import Image from "next/image";
import { useTranslation } from "next-i18next";
import './styles/_leading-company.module.scss';

const LOGO_SRC = "/images/product-page-client-logos.png";
const LOGO_WIDTH = 1042;
const LOGO_HEIGHT = 64;

const LeadingCompany = () => {
    const { t } = useTranslation("common");

    return (
        <div className="leading-company">
            <p>{t('cta.trustedBy')}</p>
            <div className="leading-company__logo">
                <Image
                    src={LOGO_SRC}
                    alt="Middleware Logo"
                    width={LOGO_WIDTH}
                    height={LOGO_HEIGHT}
                    sizes="(max-width: 768px) 100vw, 1042px"
                    priority
                />
            </div>
        </div>
    )
}

export default LeadingCompany